export const environment = {
  serverUrl: 'https://front.inte.cycloan.fr:443/',
  production: false,
  itemPerPage: 10,
  roles: [
    'superAdmin',
    'user'
  ],
  defaultLanguage: 'fr',
  defaultDashboardRefreshInterval: 120,
  osmUrl: 'https://tile.inte.cycloan.fr/{z}/{x}/{y}.png',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts